import { APICore } from './apiCore'

const api = new APICore()

function getSeaFlags (params) {
  const baseUrl = '/sea-flags'
  return api.get(baseUrl, params)
}

function getSeaFlag (id) {
  const baseUrl = `/sea-flags/${id}`
  return api.get(baseUrl, {})
}

function addSeaFlag (params) {
  const baseUrl = '/sea-flags'
  return api.createWithFile(baseUrl, params)
}

function updateSeaFlag (params) {
  const baseUrl = '/sea-flags'
  return api.updateWithFile(baseUrl, params)
}

function deleteSeaFlag (params) {
  const baseUrl = '/sea-flags'
  return api.delete(baseUrl, params)
}

export { getSeaFlags, getSeaFlag, addSeaFlag, updateSeaFlag, deleteSeaFlag }
